module.exports = __webpack_public_path__ + "img/default_user.6f5292e6.png";